var render = function render(){var _vm=this,_c=_vm._self._c;return _c('admin-wrapper',{attrs:{"has-buttons":false,"inputs":_vm.inputs,"is-form-fetched":_vm.isFetched,"is-custom-saving":_vm.saving,"straight-title":_vm.additionalModuleName,"moduleEnabler":_vm.moduleEnabler},scopedSlots:_vm._u([{key:`reports.input`,fn:function(){return [_c('custom-reports-list-panel')]},proxy:true}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }